import { restrictedAccess } from '../middleware'

export default {
  path: 'quotations',
  component: () => import('@/views/admin/quotations/Page.vue'),
  beforeEnter: restrictedAccess(1),
  children: [
    {
      name: 'Quotations.Index',
      path: '',
      component: () => import('@/views/admin/quotations/Index.vue'),
    },
    {
      name: 'Quotations.Create',
      path: 'create',
      component: () => import('@/views/admin/quotations/Create.vue'),
    },
    {
      name: 'Quotations.Edit',
      path: ':quotationId/edit',
      component: () => import('@/views/admin/quotations/Edit.vue'),
    },
    {
      name: 'Quotations.Show',
      path: ':quotationId/show',
      component: () => import('@/views/admin/quotations/Show.vue'),
    },
  ],
}